import { useEffect, useState } from "react";
import AxiosInstance from "../services/Api";

/* Handle wrapped ({ data: { status, data } }) OR interceptor-unwrapped
   ({ status, data }) responses. */
export const apiBody = (res) => (res?.data?.data !== undefined ? res.data : res) || {};

const EMPTY_BODY = {};

/**
 * POST a payload and expose `{ data, loading, error }`.
 *
 * Refetches whenever `url` or the `body` reference changes, so keep `body`
 * referentially stable (component state, a `useMemo`, or a module constant) —
 * an inline object literal would refetch on every render.
 */
export default function usePostData(url, body = EMPTY_BODY, { skip = false } = {}) {
  const [state, setState] = useState({ data: null, loading: !skip, error: null });

  useEffect(() => {
    if (skip) return undefined;
    let alive = true;
    setState((prev) => ({ ...prev, loading: true, error: null }));

    AxiosInstance.post(url, body)
      .then((res) => {
        if (!alive) return;
        const payload = apiBody(res);
        setState({
          data: payload?.status ? payload.data : null,
          loading: false,
          error: payload?.status ? null : payload?.message || "Unable to load data.",
        });
      })
      .catch((err) => {
        console.error(`${url} fetch failed`, err);
        if (alive) setState({ data: null, loading: false, error: "Unable to load data." });
      });

    return () => {
      alive = false;
    };
  }, [url, body, skip]);

  return state;
}
